import { render, staticRenderFns } from "./MultiUpload.vue?vue&type=template&id=c47c7884&scoped=true&"
import script from "./MultiUpload.vue?vue&type=script&lang=js&"
export * from "./MultiUpload.vue?vue&type=script&lang=js&"
import style0 from "./MultiUpload.vue?vue&type=style&index=0&id=c47c7884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47c7884",
  null
  
)

export default component.exports